import { darken, lighten, alpha } from '@mui/material/styles'
import { brandedTokens } from '@/theme/tokens'

const colors = {
    white: brandedTokens.brand.background.paper,
    textWhite: '#ffffff',
    textPrimary: brandedTokens.brand.text.primary,

    primary: brandedTokens.variables.primary,
    secondary: brandedTokens.variables.secondary,
    success: brandedTokens.variables.success,
    error: brandedTokens.variables.error,
    warning: brandedTokens.variables.warning,

    gray200: brandedTokens.variables.secondaryScale[20],
}

export type ButtonColor =
    | 'primary'
    | 'secondary'
    | 'success'
    | 'error'
    | 'light'
    | 'warning'

export const buttonColorMap: Record<
    ButtonColor,
    {
        base: string
        text: string
        hover: string
        active: string
        border: string
        focusRing?: string
    }
> = {
    primary: {
        base: colors.primary,
        text: colors.textPrimary,
        border: darken(colors.primary, 0.1),
        hover: darken(colors.primary, 0.1),
        active: lighten(brandedTokens.brand.primary.main, 0.3),
    },

    secondary: {
        base: colors.secondary,
        text: colors.textWhite,
        border: darken(colors.secondary, 0.07),
        hover: darken(colors.secondary, 0.15),
        active: darken(colors.secondary, 0.3),
    },

    success: {
        base: alpha(colors.success, 0.7),
        text: darken(colors.success, 0.8),
        border: colors.success,
        hover: colors.success,
        active: darken(colors.success, 0.05),
    },

    error: {
        base: colors.error,
        text: colors.textWhite,
        border: darken(colors.error, 0.1),
        hover: darken(colors.error, 0.1),
        active: darken(colors.error, 0.2),
    },

    light: {
        base: colors.white,
        text: colors.textPrimary,
        border: colors.gray200,
        hover: brandedTokens.variables.secondaryScale[20],
        active: brandedTokens.variables.secondaryScale[40],
    },

    warning: {
        base: alpha(colors.warning, 0.7),
        text: darken(colors.warning, 0.8),
        border: colors.warning,
        hover: colors.warning,
        active: darken(colors.warning, 0.05),
    },
}
